module.exports = __webpack_public_path__ + "static/media/social-icons.88fe9cb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/social-icons.png
// module id = 1259
// module chunks = 0